import { defineMessages } from '@transcend-io/internationalization';

export const draftBannerMessages = defineMessages(
  'privacy-center.containers.DraftPrivacyCenterBanner.draftBanner',
  {
    viewingDraftDescription: {
      defaultMessage: 'You are viewing a draft version of the Privacy Center',
    },
    viewLive: {
      defaultMessage: 'View Live',
    },
  },
);
